import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSelector } from "react-redux";
import { LargeWidget } from "../widgets/LargeWidget";
import * as authSelectors from "../../auth/authSelectors";
import { SmallWidgetInternal } from "../widgets/SmallWidgetInternal";
import { routes } from "../../../appRoutingHelpers";
import { CardHeader } from "../../../components/CardHeader";

export const DashboardHomeSection = () => {
  const user = useSelector(authSelectors.name);
  const organization = useSelector(authSelectors.selectedOrganizationKeyName);

  return (
    <div className="card">
      <CardHeader title="Home" subtitle={`Welcome back, ${user} 👋`} />
      <div className="card-body d-flex flex-column">
        <div className="row">
          <div className="col-12 col-lg-4 mb-4 mb-lg-0">
            <LargeWidget
              header="Go to analytics"
              buttonText="Go to analytics"
              isExternalLink={true}
              to="https://mixpanel.com/login/"
              subtitle="Go to anaytics and explore your business
                  and create cohorts."
              icon={<FontAwesomeIcon icon={solid("chart-line")} />}
            ></LargeWidget>
          </div>
          <div className="col-12 col-lg-4 mb-4 mb-lg-0">
            <LargeWidget
              header="Send messages"
              buttonText="Send messages"
              isExternalLink={true}
              to="https://dashboard.onesignal.com/login"
              subtitle="Send and customize push messages and emails."
              icon={<FontAwesomeIcon icon={solid("message-dots")} />}
            ></LargeWidget>
          </div>
          <div
            className="d-flex flex-column col-12 col-lg-4"
            style={{ gap: "16px" }}
          >
            <div className="row-4">
              <SmallWidgetInternal
                header="Find users"
                subtitle="Search, find and manage people."
                to={routes.userList(organization)}
                icon={<FontAwesomeIcon icon={solid("user")} />}
              />
            </div>
            <div className="row-4">
              <SmallWidgetInternal
                header="Manage orders"
                subtitle="Search, find and manage orders."
                to={routes.orderList(organization)}
                icon={<FontAwesomeIcon icon={solid("tag")} />}
              />
            </div>
            <div className="row-4">
              <SmallWidgetInternal
                header="Manage restaurants"
                subtitle="Create, delete and update restaurants."
                to={routes.venueList(organization)}
                icon={<FontAwesomeIcon icon={solid("fork-knife")} />}
              />
            </div>
            <div className="row-4">
              <SmallWidgetInternal
                header="Manage products"
                subtitle="Create, delete and update products."
                to={routes.products(organization)}
                icon={<FontAwesomeIcon icon={solid("cart-shopping")} />}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
